'use strict';

// Constructor
var SectionLandingFurtherHelp = function () {
    $('.page-node-type-section-landing-page .promoted-content .inner').matchHeight();
    $('.paragraph--type--further-help.spf-article-box').matchHeight();
};

module.exports = SectionLandingFurtherHelp;
